import store from '@/store'
export default {
    //路由跳转时hightlight对应的菜单
    routerBeforeEach(to, from, next) {
        if(to.params.src || (to.path.indexOf("/admin/") == 0)){
            store.menu.systems.forEach(function(value, i){     
                value.activelink =false;
                value.list.forEach(function(value2, i){
                    value2.activelink = false;
                    value2.list.forEach(function(value3, i){
                        value3.activelink = false;
                        if(value3.path.indexOf("/msu") == 0){// /mus开头得path是vue菜单
                            if(to.path.indexOf("/admin/" + value3.path.replace("/msu/",""))==0){
                                value3.activelink = true;
                                value2.activelink = true;
                                value.activelink = true;
                            }
                        }else{// 非/mus开头的是jsp菜单
                            if(decodeURIComponent(to.params.src) == (store.ctx+value3.path)){
                                value3.activelink = true;
                                value2.activelink = true;
                                value.activelink = true;
                            }
                        }    
                    });
                });
            });
        }
        next();
    }
}


// WEBPACK FOOTER //
// ./src/components/utils/MenuUtils.js